window.onload = function() {
  var $ = jQuery;

  new WOW().init();

  var animate = function(items) {
    [...items].forEach(item => {
      if (item.getBoundingClientRect().top < window.innerHeight) {
        item.style.transform = "translateY(0)";
      }
    });
  };

  var hideTopMenu = function() {
    document.getElementById("header-menu").style.top = "-100px";
    document.getElementById("subNavContainer").style.top = "0px";
  };

  var showTopMenu = function() {
    document.getElementById("header-menu").style.top = "0px";
    document.getElementById("subNavContainer").style.top = "100px";
  };

  var prevScroll = 0;
  window.onscroll = function() {
    //Parallax Effect
    var frontItems = document.getElementsByClassName("parallax-front");
    var backItems = document.getElementsByClassName("parallax-back");
    animate(frontItems);
    animate(backItems);

    //hide top menu
    if (window.scrollY > window.innerHeight) {
      hideTopMenu();
    }

    //show top menu
    if (prevScroll > window.scrollY) {
      showTopMenu();
    }

    prevScroll = window.scrollY;
  };

  //dropdown hover
  $(
    "#header-menu .menu-item-has-children, #subNavContainer .menu-item-has-children"
  ).mouseenter(function() {
    if (!this.classList.contains("subnav-search")) {
      var child = this.children[1];
      child.style.opacity = "1";
      child.style.visibility = "visible";
    }
  });

  //dropdown hover
  $(
    "#header-menu .menu-item-has-children, #subNavContainer .menu-item-has-children"
  ).mouseleave(function() {
    if (!this.classList.contains("subnav-search")) {
      var child = this.children[1];
      child.style.opacity = "0";
      child.style.visibility = "hidden";
    }
  });

  //Open subnav search
  $(
    "#subNavContainer .subnav-search a"
  ).click(function(e) {
    e.preventDefault();
    var sib = this.nextSibling;
    if (sib.style.opacity == 0) {
      sib.style.opacity = "1";
      sib.style.visibility = "visible";
    } else {
      sib.style.opacity = "0";
      sib.style.visibility = "hidden";
    }
  });

  //Mobile subNav animations
  $("#subNavMobile .header").click(function() {
    var $this = $(this);

    //scroll nav bar to top of page
    $("html, body").animate({
      scrollTop: $this.offset().top
    });

    //open sub nav mobile
    var $openBtn = $("#openBtn i");
    if ($openBtn.attr("data-flipped") === "false") {
      $openBtn.css({ transform: "scaleY(-1)" });
      $openBtn.attr("data-flipped", "true");
    } else {
      $openBtn.css({ transform: "scaleY(1)" });
      $openBtn.attr("data-flipped", "false");
    }

    //toggle the slide out
    $this.next().slideToggle();
  });

  //prevent top level link from clicking
  $("#subNavMobile .menu-item-has-children > a").click(function(e) {
    e.preventDefault();
  });

  //open subNavMobile sub menus and rotate icons
  $("#subNavMobile .menu-item-has-children").click(function(e) {
    var $this = $(this);
    // open sub nav mobile accordions
    if ($this.find(".sub-menu").css("display") === "none") {
      //reset
      $(".sub-menu").slideUp("fast");
      $(".menu-item-has-children").removeClass("open");
      $(".menu-item").removeClass("openBorder");

      //add styles
      $this.find(".sub-menu").slideDown("fast");
      $this.addClass("open");
      $this.prev().addClass("openBorder");
    }
  });

  //open the current page accordion on load
  var currentMenuItem = $("#subNavMobile .current-page-parent");
  currentMenuItem.find(".sub-menu").slideDown("fast");
  currentMenuItem.addClass("open");
  currentMenuItem.prev().addClass("openBorder");

  //accordion icon rotation
  $(".accordion-item").on("show.bs.collapse", function() {
    $("i", this).addClass("open");
  });
  $(".accordion-item").on("hide.bs.collapse", function() {
    $("i", this).removeClass("open");
  });

  //open header mobile menu
  $("#header-menu-mobile .logo-container .open").click(function() {
    $(this).fadeOut(100, function() {
      $("#header-menu-mobile .logo-container .close").fadeIn(100);
    });
    $("#header-menu-mobile .menu-container").slideDown("fast");
  });
  //close header mobile menu
  $("#header-menu-mobile .logo-container .close").click(function() {
    $(this).fadeOut(100, function() {
      $("#header-menu-mobile .logo-container .open").fadeIn(100);
    });
    $("#header-menu-mobile .menu-container").slideUp("fast");

    //close any open sub-menus when whole nav closes
    var allItems = $("#header-menu-mobile .menu-item-has-children");
    allItems.find(".sub-menu").slideUp("fast");
    allItems
      .css({ borderTop: "1px solid #fff", color: "#fff" })
      .removeClass("rotate");
    $("#header-menu-mobile .social-media").css("position", "absolute");
  });

  //prevent top level link from clicking
  $("#header-menu-mobile .menu-item-has-children > a").click(function(e) {
    e.preventDefault();
  });

  $("#header-menu-mobile .menu-item-has-children").click(function(e) {
    // open sub nav mobile accordions
    if (
      $(this)
        .find(".sub-menu")
        .css("display") === "none"
    ) {
      //reset
      var allItems = $("#header-menu-mobile .menu-item-has-children");
      allItems.find(".sub-menu").slideUp("fast");
      allItems
        .css({ borderTop: "1px solid #fff", color: "#fff" })
        .removeClass("rotate");

      //add styles
      $(this)
        .find(".sub-menu")
        .slideDown("fast")
        .css("borderTop", "1px solid #33b9b5")
        .addClass("slideOpen");
      $(this)
        .css({ borderTop: "1px solid #33b9b5", color: "#33b9b5" })
        .addClass("rotate");
      $("#header-menu-mobile .social-media").css("position", "relative");
    }
  });

  //open search bar on main mobile nav
  $("#header-menu-mobile #search-open").click(function() {
    $(this).animate({ opacity: "0" }, 200);

    $("#header-menu-mobile .search-container").slideToggle("fast");
  });

  //prevent sub nav top level links from clicking, except the first one
  $("#subNav .menu-item-has-children > a").click(function(e) {
    e.preventDefault();
  });

  $(".hp-leadership .leadership-item").on('click', function (e) {
      e.preventDefault();
      $('#leadership-biography-image img').attr('src', '');
      $('#leadership-biography-image img').attr('src', $(this).data('biography-image'));
      // $('#leadership-biography-image').css('background-image', '');
      // $('#leadership-biography-image').css('background-image', 'url('+$(this).data('biography-image')+')');

      $('#biography-text .biography-text-container').html('');
      $('#biography-text .biography-text-container').html($(this).data('biography-text'));

      $('#leadership-biography-modal').modal({
          backdrop: 'static',
          keyboard: false
      });
  });
};
